<template>
    <div>
        <avue-crud :data="data" :option="option" :page.sync="page" :search.sync="search" @current-change="changePage"
                   @search-change="searchChange" @search-reset="resetChange" @selection-change="selectionChange">
            <template slot="menuBtn" slot-scope="scope">
                <el-dropdown-item class="pull-down" @click.native="downloadBtn(scope.row)">下载</el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="evidenceBtn(scope.row)"
                           v-if="scope.row.is_faqiren == 1 && scope.row.is_zhcai == 0 && userData.platform_sn != 2">保存证据
                </el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="transferBtn(scope.row)"
                           v-if="scope.row.is_zhcai==0&&scope.row.is_faqiren==1">转为案件
                </el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="viewBtn(scope.row)">查看</el-dropdown-item>

            </template>
            <template slot="menuLeft"  slot-scope="scope" >
                <el-button  class="View" @click="bindBtn" v-if="userData.platform_sn != 2">绑定证据清单</el-button>
            </template>
            <template slot-scope="scope" slot="is_zhcai">
                <span v-if="scope.row.is_zhcai == 1">已转入</span>
                <span v-else>未转入</span>
            </template>
            <template slot="doc_title" slot-scope="scope" >
                <el-tooltip :content="scope.row.doc_title" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.doc_title }}</p>
                </el-tooltip>
            </template>
            <template slot="system_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.system_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.system_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="contract_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.contract_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.contract_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="faqi_ren" slot-scope="scope" >
                <el-tooltip :content="scope.row.faqi_ren" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.faqi_ren }}</p>
                </el-tooltip>
            </template>
            <template slot="all_signers" slot-scope="scope" >
                <el-tooltip :content="scope.row.all_signers" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.all_signers }}</p>
                </el-tooltip>
            </template>
        </avue-crud>
        <el-dialog
                title="提示"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                width="30%">
            <el-radio v-model="radio" label="1">转入仲裁案件</el-radio>
            <el-radio v-model="radio" label="2">转入调解案件</el-radio>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmTransferBtn">确 定</el-button>
            </span>
        </el-dialog>
        <!--        关联证据清单-->
        <el-dialog
            title="关联证据清单"
            :visible.sync="relation"
            :close-on-click-modal="false"
            width="60%">
            <div class="relation">
                <avue-crud :data="inventoryData" :option="option2">
                    <template slot-scope="scope" slot="menu">
                        <el-button class="customize" @click="bindListBtn(scope.row)">绑定</el-button>
                    </template>
                </avue-crud>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="relation = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { associatedList, bindEvidence, contractList, contractSearch, downloadContract } from '../../../api/contract';

    export default {
        name: 'complete',
        data() {
            return {
                page: {
                    currentPage: 1,
                    total: 60,  //总数
                    pageSize: 10 //每页多少
                    // pagerCount:5
                },
                userData:'',
                dialogVisible:false,
                radio: '1',
                transferId:'',
                data: [],
                doc_title: '',
                all_signers: '',
                search: {
                    doc_title: '',
                    all_signers: ''
                },
                relation:false,
                inventoryData:[],
                pages: 1,
                option: {
                    menuType: 'menu',
                    selection: true, //批量选择
                    menuBtnTitle:'操作',
                    align: 'center',
                    menuAlign: 'center',
                    editBtn: false,
                    delBtn: false,
                    menuWidth: 150,//操作栏宽度设置
                    rowKey: 'ids',
                    refreshBtn: false, //刷新按钮
                    columnBtn: false, //表格右侧操作列显隐的按钮
                    addBtn: false, //左上角新增
                    column: [
                        {
                            label: '合同名称',
                            prop: 'doc_title',
                            search: true
                        },
                        {
                            label: '平台编号',
                            prop: 'system_sn'
                        },
                        // {
                        //     label: '合同编号',
                        //     prop: 'contract_sn'
                        // },
                        {
                            label: '发起人',
                            prop: 'faqi_ren'
                        }, {
                            label: '发起时间',
                            prop: 'faqi_time'
                        }, {
                            label: '参与人',
                            prop: 'all_signers',
                            width:'500',
                            search: true,
                        }, {
                            label: '合同状态',
                            width: '60',
                            prop: 'ct_status_txt'
                        }, {
                            label: '合同完成时间',
                            prop: 'finish_time'
                        }, {
                            label: '签署截止时间',
                            prop: 'expire_time'
                        }, {
                            label: '是否转入仲裁',
                            prop: 'is_zhcai',
                            width: '60',
                            slot: true,

                        }

                    ]
                },
                option2: {
                    stripe: true,
                    addBtn: false,  //新增按钮
                    align: 'center',  //文本居中
                    menuAlign: 'center', //操作栏居中
                    columnBtn: false,  //列动态显隐按钮
                    refreshBtn: false,  //刷新按钮
                    editBtn: false,  //编辑按钮
                    delBtn: false,  //删除按钮
                    menuWidth: 300,  //操作栏宽度设置
                    column: [
                        {
                            label: '证据清单id',
                            prop: 'id'
                        },
                        {
                            label: '证据清单名称',
                            prop: 'name'
                        }
                    ]
                }
            };
        },
        methods: {
            //批量操作
            selectionChange(list){
                this.ids = []
                list.forEach(res=>{
                    this.ids.push(res.id)
                })
            },
            //分页
            changePage(num) {
                if (this.doc_title == '' && this.all_signers == '') {
                    contractList(5, 10, num).then(res => {
                        sessionStorage.setItem('complete', num);
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                    });
                } else {
                    //搜索后分页
                    contractSearch(5, 10, num, this.doc_title, this.all_signers).then(res => {
                        if (res.code == 200) {
                            sessionStorage.setItem('completeSearch', num);
                            this.data = res.data.list;
                            this.page.total = res.data.count;
                        }
                    });
                }
            },
            //搜索
            searchChange(from, done) {
                contractSearch(5, 10, 1, from.doc_title, from.all_signers).then(res => {
                    this.doc_title = from.doc_title;
                    this.all_signers = from.all_signers;
                    if (res.code == 200) {
                        sessionStorage.setItem('completeSearch', 1);
                        sessionStorage.setItem('completeParams', JSON.stringify(from));
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        this.page.currentPage = 1;
                    }
                });
                done();
            },
            //重置搜索
            resetChange() {
                this.doc_title = '';
                this.all_signers = '';
                contractList(5, 10, this.pages).then(res => {
                    if (res.code == 200) {
                        sessionStorage.removeItem('complete');
                        sessionStorage.removeItem('completeSearch');
                        sessionStorage.removeItem('completeParams');
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        this.page.currentPage = 1;
                        this.$message.success('重置成功');
                    }

                });
            },
            //下载
            downloadBtn(row) {
                downloadContract(row.id).then(res => {
                    window.open(res.data.download_url, "_blank");
                });
            },
            //保存证据
            evidenceBtn(row) {
                this.$router.push({ path: '/evidenceList', query: { id: row.id, is_main: '0' } });
            },
            //转入仲裁
            transferBtn(row) {
                this.dialogVisible=true
                this.transferId=row.id
            },
            //转入仲裁
            confirmTransferBtn(){
                if (this.radio==1){
                    this.$router.push({ path: '/arbitrate', query: { id: this.transferId } });
                }else {
                    this.$router.push({path:'/transferMediate',query:{id: this.transferId}})
                }

            },
            //查看
            viewBtn(row) {
                this.$router.push({ path: '/detailsPage', query: { id: row.id } });
            },
            // 绑定清单
            bindBtn(){
                if (this.ids == undefined || this.ids == '') {
                    this.$message.error('请选择要关联的合同');
                    return;
                } else {
                    associatedList().then(res => {
                        this.relation = true;
                        this.inventoryData = res.data.list;
                    });
                }
            },
            // 绑定
            bindListBtn(row){
                bindEvidence({signer_list_ids:this.ids,product_id:row.id}).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg)
                        this.relation = false;
                    }else {
                        this.$message.error(res.msg)
                        this.relation = false;
                    }
                })
            }
        },
        created() {
            this.userData = JSON.parse(localStorage.getItem('userData'));
            if (sessionStorage.getItem('completeSearch')) {
                let completeParams = JSON.parse(sessionStorage.getItem('completeParams'));
                this.search = completeParams;
                this.doc_title = completeParams.doc_title;
                this.all_signers = completeParams.all_signers;
                contractSearch(5, 10, sessionStorage.getItem('completeSearch'), this.doc_title, this.all_signers).then(res => {
                    if (res.code == 200) {
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        this.page.currentPage = sessionStorage.getItem('completeSearch');
                    }
                });
            } else {
                if (sessionStorage.getItem('complete') === null) {
                    contractList(5, 10, this.pages).then(res => {
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        this.page.currentPage = 1;
                    });
                } else {
                    contractList(5, 10, sessionStorage.getItem('complete')).then(res => {
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        this.page.currentPage = sessionStorage.getItem('complete');
                    });
                }
            }

        }
    };
</script>

<style scoped>
    /deep/ .el-col {
        width: 25%;
    }

    /deep/ .avue-form__menu {
        padding: 0px;
    }

    /deep/ .el-tabs__active-bar {
        background-color: #3d62f6;
    }

    .View {
        background: #3d62f6;
        color: #fff;
    }
    /deep/.el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }
    /deep/.el-icon-arrow-down {
        font-size: 15px;
    }
    .pull-down{
        padding: 5px 30px !important;
    }
    .textStyle{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: default;
        margin:0;
    }
    .customize {
        background-color: #1d63f5;
        color: #fff;
    }
</style>
